<template>
  <div class="guard-success">
    
    
      <div class="apply-info">
        <img src="./ok.png" alt />
        <h4>恭喜您申请成功</h4>
      </div>
      <div class="apply-contact">
        <p>系统为您分配了对接工作人员，请扫码添加微信进行一对一沟通</p>
        <p style="color:#e95c4e">
          申请 - 请备注姓名
          <br />例：寻求工作 - 马雄二
        </p>
        <p class="ecode" v-if="type == 1">
          <img src="./ma.png" alt="">
        </p>
        <p class="ecode" v-if="type == 2">
          <img src="./cong.jpeg" alt="">
        </p>
      </div>
  </div>
</template>

<style lang="scss" scoped>
.guard-success {
  // 隐藏最上方1px边框
  margin-top: -1px;
  padding-bottom: 30px;

  .step4 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f5f5f5;

    .btns {
      margin-top: 35px;
    }
  }

  .apply-info {
    img {
      width: 75px;
      margin: 35px auto;
      display: block;
    }

    h4 {
      font-size: 18px;
      line-height: 20px;
      text-align: center;
    }

    p {
      text-align: center;
      color: #666;
      margin-top: 10px;
    }
  }

  .apply-contact {
    
    p {
      margin: 0 15px;
      margin-top: 20px;
      color: #666;
    }
    .ecode {
      padding-bottom:20px;
      
      img {
        max-height: 300px;
        display: block;
        margin:0 auto;
      }
    }
  }

}
</style>


<script>


export default {
  name: "register-hc-module",
  data() {
    return {
      step: 1,
      type:this.$route.query.type || 1
    };
  },
  watch: {
    
  },
  components: {},
  computed: {
    
  },
  methods: {
    
  },
  created() {
    this.$store.commit('comp/WX_SHARE',{
      title:'守卫猎头计划开启',
      desc:'猎上网推出五大扶持猎头政策',
      link:window.location.origin + '/hh-wx/activity/guardhunter'
    });
  }
};
</script>
